import React from 'react'
import PropTypes from 'prop-types'
import styles from './AccountHolderReview.module.scss'
import AccountHolderSection from '../AccountHolderSection/AccountHolderSection'
import {
  ONBOARDING_PERSONAL_INFORMATION_PATH,
  ONBOARDING_IDENTITY_VERIFICATION_PATH,
  ONBOARDING_EMPLOYMENT_DETAILS_PATH
} from 'utils/urlPaths'

const AccountHolderReview = (props) => {
  const {
    personalInformationComplete,
    identityVerificationComplete,
    employmentDetailsComplete
  } = props

  return (
    <div className={styles.AccountHolderReview}>
      <h2>About You</h2>
      <div className={styles.AccountHolderRow}>
        <AccountHolderSection
          isComplete={personalInformationComplete}
          path={ONBOARDING_PERSONAL_INFORMATION_PATH}
          section="Personal Information" />
        <AccountHolderSection
          isComplete={identityVerificationComplete}
          path={ONBOARDING_IDENTITY_VERIFICATION_PATH}
          section="Identity Verification" />
        <AccountHolderSection
          isComplete={employmentDetailsComplete}
          path={ONBOARDING_EMPLOYMENT_DETAILS_PATH}
          section="Employment Details" />
      </div>
    </div>
  )
}

AccountHolderReview.propTypes = {
  personalInformationComplete: PropTypes.bool.isRequired,
  identityVerificationComplete: PropTypes.bool.isRequired,
  employmentDetailsComplete: PropTypes.bool.isRequired
}

export default AccountHolderReview



// WEBPACK FOOTER //
// ./src/components/Onboarding/ReviewAndSubmit/AccountHolderReview/AccountHolderReview.jsx